import React from 'react';
import clsx from 'clsx';
import IconButton from '@mui/material/IconButton';
import isEmpty from 'lodash/isEmpty';
import ToolTip from 'core/components/Tooltip';
import {
  AIIcon,
} from 'core/icons';
import {
  useFormContext,
} from 'react-hook-form';
import {
  VisitNoteData,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/components/MainContent';
import {
  useGetHPIParagraph,
  useSaveVisitNote,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/hooks';
import {
  ToolbarItemProps,
} from 'views/EMR/components/TextAreaToolbar/index';

export default function HPIAIToolbarItem({
  setData,
}: ToolbarItemProps) {
  const { watch } = useFormContext<VisitNoteData>();
  const { mutateAsync: saveVisitNote, isPending: savingVisitNote } = useSaveVisitNote();
  const visitNote = watch();
  const { refetch, isFetching } = useGetHPIParagraph(visitNote.encounterId ?? 0);
  const hasHPI = !isEmpty(visitNote.hpi?.hpiFromIntakeElements);
  const onClick = async () => {
    if ((visitNote?.hpi?.hpiFromIntakeElements?.length ?? 0) > 0) {
      await saveVisitNote(visitNote);
      const { data } = await refetch();
      setData(data ?? '');
    }
  };

  return (
    <ToolTip
      title={hasHPI ? 'Use AI' : 'HPI was not provided'}
    >
      <div className={clsx({
        'cursor-not-allowed': !hasHPI,
      })}
      >
        <IconButton
          className="nw-ai-button"
          onClick={onClick}
          disabled={isFetching || !hasHPI || savingVisitNote}
        >
          <AIIcon className="!w-4 !h-4 !text-inherit" />
        </IconButton>
      </div>
    </ToolTip>
  );
}
